<template>
  <form @submit.prevent="submit()" class="p-2">
    <b-row>
      <b-col>
        <label>{{$t("views.exsbmessagesperiodic.form.state")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" v-model="item.state" name="radioSubComponent">
            <b-form-radio button-variant="outline-success" :value="1">{{$t("buttons.on")}}</b-form-radio>
            <b-form-radio button-variant="outline-danger" :value="0">{{$t("buttons.off")}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col v-show="item.messageType.includes('1')">
        <label>{{$t("views.exsbmessagesperiodic.form.idSenderTypeMail")}}:</label>
        <model-select v-model="item.idSenderTypeMail" :options="senderTypeOptions" name="type" :placeholder="$t('views.exsbmessagesperiodic.form.idSenderTypeMail')"></model-select>
      </b-col>
      <b-col v-show="item.messageType.includes('2')">
        <label>{{$t("views.exsbmessagesperiodic.form.idSenderTypeSms")}}:</label>
        <model-select v-model="item.idSenderTypeSms" :options="senderTypeOptions" name="type" :placeholder="$t('views.exsbmessagesperiodic.form.idSenderTypeSms')"></model-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label>{{$t("views.exsbmessagesperiodic.form.title")}}:</label>
        <input v-model="item.title" name="title" type="text" autofocus :placeholder="$t('views.exsbmessagesperiodic.form.title')" class="form-control"/>
      </b-col>
      <b-col>
        <label>{{$t("views.exsbmessagesperiodic.form.subject")}}:</label>
        <input v-model="item.subject" name="subject" type="text" autofocus :placeholder="$t('views.exsbmessagesperiodic.form.subject')" class="form-control"/>
      </b-col>
      <b-col>
        <label>{{$t("global.type")}}:</label>
        <b-form-group>
          <b-form-checkbox-group v-model="item.messageType" class="" id="massagetype">
            <b-form-checkbox value="1">{{$t("views.exsbmessagesperiodic.form.messageTypes.mail")}}</b-form-checkbox>
            <b-form-checkbox value="2">{{$t("views.exsbmessagesperiodic.form.messageTypes.sms")}}</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label>{{$t("views.exsbmessagesperiodic.form.sendByDateType")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" v-model="item.sendByDate" name="radioSubComponent">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t("buttons.yes")}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t("buttons.no")}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col v-if="(item.sendByDate === 1 && item.sendingDaysOption !== 0 && item.sendingDaysOption !== 1) || item.sendByDate === 0">
        <label>{{$t("views.exsbmessagesperiodic.form.vindication")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" v-model="item.vindication" name="radioSubComponent">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t("buttons.yes")}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t("buttons.no")}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col>
        <label>{{$t("views.exsbmessagesperiodic.form.autoAccept")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" v-model="item.autoAccept" name="radioSubComponent">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t("buttons.yes")}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t("buttons.no")}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-form-group>
        <content-field-invoices-legend></content-field-invoices-legend>
      </b-form-group>
    </b-row>
    <b-row>
      <b-col v-if="item.sendByDate == 1">
        <label>{{$t("views.exsbmessagesperiodic.form.sendingDaysOption")}}:</label>
        <model-select @input="onSelectDaysOption($event)" v-model="item.sendingDaysOption" :options="sendByDateTypes" name="type" :placeholder="$t('views.exsbmessagesperiodic.form.sendingDaysOption')"></model-select>
      </b-col>
      <b-col v-if="item.sendByDate == 0">
        <label>{{$t("views.exsbmessagesperiodic.form.sendingDays")}}:</label>
        <input v-b-tooltip.hover :title="$t('views.exsbmessagesperiodic.form.sendingDaysTooltip')" v-model="item.sendingDays" name="subject" type="text" autofocus :placeholder="$t('views.exsbmessagesperiodic.form.sendByDateType')" class="form-control"/>
      </b-col>
      <b-col v-if="item.sendByDate == 1 && item.sendingDaysOption !== 2">
        <label>{{$t("views.exsbmessagesperiodic.form.shiftDateFromNow")}}:</label>
        <input v-model="item.shiftDateFromNow" name="shiftDateFromNow" type="number" autofocus :placeholder="$t('views.exsbmessagesperiodic.form.shiftDateFromNow')" class="form-control"/>
      </b-col>
      <b-col v-if="item.sendByDate == 1 && item.sendingDaysOption === 2">
        <label>{{$t("views.exsbmessagesperiodic.form.agreementArrearsDays")}}:</label>
        <input v-model="item.agreementArrearsDays" name="agreementArrearsDays" type="number" autofocus :placeholder="$t('views.exsbmessagesperiodic.form.agreementArrearsDays')" class="form-control"/>
      </b-col>
      <b-col v-if="(item.sendByDate == 0) || (item.sendByDate == 1 && (item.sendingDaysOption == 1 || item.sendingDaysOption == 2) )">
        <label>{{$t("views.exsbmessagesperiodic.form.fromValue")}}:</label>
        <input v-model="item.fromValue" name="fromValue" type="text" autofocus :placeholder="$t('views.exsbmessagesperiodic.form.fromValue')" class="form-control"/>
      </b-col>
      <b-col v-if="(item.sendByDate == 0) || (item.sendByDate == 1 && (item.sendingDaysOption == 1 || item.sendingDaysOption == 2) )">
        <label>{{$t("views.exsbmessagesperiodic.form.toValue")}}:</label>
        <input v-model="item.toValue" name="toValue" type="text" autofocus :placeholder="$t('views.exsbmessagesperiodic.form.toValue')" class="form-control"/>
      </b-col>
      <b-col v-if="item.sendByDate == 1 && item.sendingDaysOption !== 2">
        <label>{{$t("views.exsbmessagesperiodic.form.invoiceStatusTypes")}}:</label>
        <b-form-group>
          <b-form-checkbox-group v-model="item.invoiceStatusTypes" class="" id="massagetype">
            <b-form-checkbox value="1">{{$t("views.exsbmessagesperiodic.form.invoiceStatuses.notPaid")}}</b-form-checkbox>
            <b-form-checkbox value="3">{{$t("views.exsbmessagesperiodic.form.invoiceStatuses.notFull")}}</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label>{{$t("views.exsbmessagesperiodic.form.blockApplication")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" v-model="item.blockApplication" name="radioSubComponent">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t("buttons.yes")}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t("buttons.no")}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="item.messageType.includes('2')">
      <b-col>
        <label>{{$t("views.exsbmessagesperiodic.form.contentSms")}}:</label>
        <textarea v-model="item.contentSms" name="contentSms" type="text" autofocus :placeholder="$t('views.exsbmessagesperiodic.form.contentSms')" class="form-control"></textarea>
      </b-col>
    </b-row>
    <b-row v-show="item.messageType.includes('1')">
      <b-col>
        <label>{{$t("views.exsbmessagesperiodic.form.contentEmail")}}:</label>
        <trumbowyg ref="editor" v-model="item.contentEmail" :config="trumbowygConfig" class="form-control" name="htmlContent">
        </trumbowyg>
      </b-col>
    </b-row>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min'
import { mapGetters, mapActions } from 'vuex'
import ApiService from '@/utils/ApiService'
import ContentFieldInvoicesLegend from '@/components/Dashboard/Views/Pages/AppConfiguration/components/contentFieldInvoicesLegend.vue'

export default {
  name: 'Form',
  props: ['values', 'initialValues', 'handleSubmit', 'violations'],
  components: {
    ContentFieldInvoicesLegend,
    ModelSelect,
    Trumbowyg
  },
  data () {
    return {
      senderTypeOptions: [],
      sendByDateTypes: [
        { value: 1, text: this.$t('views.exsbmessagesperiodic.form.sendByDateTypes.documentPaymentDate') },
        { value: 2, text: this.$t('views.exsbmessagesperiodic.form.sendByDateTypes.agreementArrearsDays') }
      ],
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      }
    }
  },
  computed: {
    item () {
      return this.initialValues || this.values
    },
    ...mapGetters({
      retrieved: 'exsbmessagesperiodic/show/retrieved',
      taskTypeOptions: 'exsbmessagesperiodic/list/taskTypeOptions',
      caseTypeOptions: 'exsbmessagesperiodic/list/caseTypeOptions',
      firingThroughOptions: 'exsbmessagesperiodic/list/firingThroughOptions',
      recipientTypeOptions: 'exsbmessagesperiodic/list/recipientTypeOptions'
    })
  },
  created () {
    this.fetchSenderTypeOptions()
  },
  methods: {
    ...mapActions({
      fetchTaskTypeOptions: 'exsbmessagesperiodic/list/fetchTaskTypeOptions',
      fetchCaseTypeOptions: 'exsbmessagesperiodic/list/fetchCaseTypeOptions'
    }),
    onSelectDaysOption (value) {
      if (value === 0 || value === 1) {
        this.form.vindication = 0
      }
    },
    submit () {
      if (this.item.shiftDateFromNow) this.item.shiftDateFromNow = parseInt(this.item.shiftDateFromNow)
      else this.item.shiftDateFromNow = 0
      this.handleSubmit()
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async fetchSenderTypeOptions () {
      let baseParams = { pagination: false }
      const response = await new ApiService('sender_types', baseParams).getResults()
      this.senderTypeOptions = response.items.map(item => {
        return {
          value: item['@id'],
          text: item.title
        }
      })
      this.senderTypeOptions.unshift({ text: this.$t('global.notSet'), value: null })
    }
  }
}
</script>

<style scoped>

</style>
